import React, { Component } from "react";
import { connect } from "react-redux";

class AlertDesktop extends Component {
  constructor(props) {
    super(props);
  
  }

  render() {
    return (
      <>
        {this.props.config.alertState[0] && (
          <div className="alert" style={{ backgroundColor: `${this.props.config.alertText[0].bgcolor}`}}>
            <span className="alert-text" style={{ color: `${this.props.config.alertText[0].color}`}}>{this.props.config.alertText[0].alertMessage}</span>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
  };
};

export default connect(mapStateToProps)(AlertDesktop);
